// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #6C63FF;
  --bg: #f8f9fa;
  --text: #2d3436;
}

body {
  margin: 0;
  font-family: 'Segoe UI', Roboto, sans-serif;
  background-color: var(--bg);
  color: var(--text);
}

.container {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}

.list-header {
  margin-bottom: 20px;
}

.list-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.count-pill {
  background: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.9em;
}

.card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.table-pro {
  width: 100%;
  border-collapse: collapse;
}

.row-click {
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #eee;
}

.row-click:hover {
  background: #f1f0ff;
}

.title-cell {
  padding: 15px;
  font-weight: 500;
}

.btn-secondary {
  background: transparent;
  border: 1px solid var(--primary);
  color: var(--primary);
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

/* Modal del SCORM */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  padding: 15px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  flex-grow: 1;
}

.icon-btn {
  background: #ff7675;
  color: white;
  border: none;
  padding: 5px 15px;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[":root {\n  --primary: #6C63FF;\n  --bg: #f8f9fa;\n  --text: #2d3436;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', Roboto, sans-serif;\n  background-color: var(--bg);\n  color: var(--text);\n}\n\n.container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 0 20px;\n}\n\n.list-header {\n  margin-bottom: 20px;\n}\n\n.list-title {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.count-pill {\n  background: var(--primary);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.9em;\n}\n\n.card {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.05);\n}\n\n.table-pro {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.row-click {\n  cursor: pointer;\n  transition: background 0.2s;\n  border-bottom: 1px solid #eee;\n}\n\n.row-click:hover {\n  background: #f1f0ff;\n}\n\n.title-cell {\n  padding: 15px;\n  font-weight: 500;\n}\n\n.btn-secondary {\n  background: transparent;\n  border: 1px solid var(--primary);\n  color: var(--primary);\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* Modal del SCORM */\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modal-header {\n  padding: 15px;\n  background: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n}\n\n.modal-body {\n  flex-grow: 1;\n}\n\n.icon-btn {\n  background: #ff7675;\n  color: white;\n  border: none;\n  padding: 5px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
